import React, { useState } from 'react';
import { generateVless, generateVmess, generateHapp } from '../utils/proxyGenerators';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiInfo, FiGlobe, FiCpu } = FiIcons;

const CF_IPS = [
  { label: 'Cloudflare SJC', ip: '104.16.89.20' },
  { label: 'Cloudflare LAX', ip: '104.16.90.20' },
  { label: 'Cloudflare SEA', ip: '104.16.91.20' },
];

export default function ConfigForm({ onGenerate }) {
  const [protocol, setProtocol] = useState('vless');
  const [formData, setFormData] = useState({
    name: 'Nexus-Edge-Node',
    uuid: 'd342d11e-d424-4583-b36e-524ab1f0afa4',
    address: CF_IPS[0].ip,
    port: '443',
    host: window.location.hostname, // Defaults to current domain
    path: '/tunnel?ed=2048'
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    let configStr = '';
    
    if (protocol === 'sub') {
      configStr = `https://${formData.host}/sub`;
      onGenerate({ type: 'subscription', string: configStr, name: 'H-APP Subscription URL' });
      return;
    }

    if (protocol === 'vless') configStr = generateVless(formData);
    else if (protocol === 'vmess') configStr = generateVmess(formData);
    else if (protocol === 'happ') configStr = generateHapp(formData);
    
    onGenerate({ type: protocol, string: configStr, name: formData.name });
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6 bg-gray-950 p-6 rounded-2xl border border-cyan-900/30">
      {/* Protocol Selector */}
      <div className="flex bg-black p-1 rounded-xl border border-gray-800 flex-wrap gap-1">
        {['vless', 'vmess', 'happ', 'sub'].map(p => (
          <button
            key={p}
            type="button"
            onClick={() => setProtocol(p)}
            className={`flex-1 py-2 px-2 text-[10px] font-black rounded-lg transition-all uppercase ${
              protocol === p ? 'bg-cyan-600 text-white' : 'text-gray-500 hover:text-gray-300'
            }`}
          >
            {p === 'sub' ? 'Subscription' : p}
          </button>
        ))}
      </div>

      <div className="grid grid-cols-1 gap-4">
        {/* SNI Input with Clarification */}
        <div>
          <div className="flex items-center justify-between mb-1">
            <label className="text-[10px] text-gray-500 uppercase font-black flex items-center gap-1">
              <SafeIcon icon={FiGlobe} className="text-cyan-500" />
              Cloudflare Pages URL (SNI)
            </label>
          </div>
          <input
            type="text"
            value={formData.host}
            onChange={(e) => setFormData({...formData, host: e.target.value})}
            placeholder="example.pages.dev"
            className="w-full bg-black border border-gray-800 rounded-lg p-3 text-sm text-cyan-400 outline-none focus:border-cyan-600 font-mono"
          />
          <p className="mt-1 text-[9px] text-gray-600 flex items-center gap-1">
            <SafeIcon icon={FiInfo} />
            Must be your project URL from Cloudflare dashboard.
          </p>
        </div>

        {/* Connection IP */}
        {protocol !== 'sub' && (
          <div>
            <label className="text-[10px] text-gray-500 uppercase font-black flex items-center gap-1 mb-1">
              <SafeIcon icon={FiCpu} className="text-cyan-500" />
              Clean IP (Connection Address)
            </label>
            <select
              value={formData.address}
              onChange={(e) => setFormData({...formData, address: e.target.value})}
              className="w-full bg-black border border-gray-800 rounded-lg p-3 text-sm text-white outline-none focus:border-cyan-600"
            >
              {CF_IPS.map(ip => <option key={ip.ip} value={ip.ip}>{ip.label} ({ip.ip})</option>)}
            </select>
          </div>
        )}
      </div>

      <button type="submit" className="w-full py-4 bg-cyan-600 hover:bg-cyan-500 text-white font-bold rounded-xl transition-all shadow-lg shadow-cyan-900/20 uppercase tracking-widest text-xs">
        {protocol === 'sub' ? 'Generate Subscription Link' : `Generate ${protocol} Config`}
      </button>
      
      <div className="p-3 bg-yellow-500/5 rounded-lg border border-yellow-500/20">
        <p className="text-[10px] text-yellow-500/80 text-center italic leading-tight">
          {protocol === 'sub' 
            ? "H-APP / Hiddify: Copy the HTTPS link and add it as a 'New Subscription'."
            : "V2Ray / Shadowrocket: Copy the config string and 'Import from Clipboard'."}
        </p>
      </div>
    </form>
  );
}